export function isMobile () {
    const userAgentInfo = navigator.userAgent
    console.log(navigator.userAgent)
    //主流系统   详细系统["iphone", "ipod", "ipad", "android", "mobile", "blackberry", "webos", "incognito", "webmate", "bada", "nokia", "lg", "ucweb", "skyfire"]
    const Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
    const getArr = Agents.filter(i => userAgentInfo.includes(i))
    return !!getArr.length
  }